import React from "react";
import { ChevronRight } from "lucide-react";
import ArrowSign from "../assets/images/arrow-sign.png";
import InfoSectionImage from "../assets/images/Extra long-lasting.png";

const PupTreatsInfoSection = () => {
  return (
    <div style={{ fontFamily: "Arial, sans-serif" }}>
      {/* Main Section */}
      <section
        style={{
          position: "relative",
          padding: "6rem 0 1rem 0",
          background: "white",
          overflow: "hidden",
        }}
      >
        {/* Large Background Text */}
        <div
          style={{
            position: "static",
            fontSize: "clamp(4rem, 15vw, 12rem)",
            fontWeight: "900",
            color: "rgba(220, 220, 220)",
            fontStyle: "italic",
            whiteSpace: "nowrap",
            zIndex: 1,
            userSelect: "none",
            lineHeight: "0.5",
            fontFamily: 'Brush Script MT, cursive',
            textAlign: "center",
            marginBottom: "2rem",
          }}
        >
          Pup n Treats
        </div>

        {/* Content Container */}
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {/* Main Heading */}
              <h2
                style={{
                  fontSize: "30px",
                  fontWeight: "600",
                  color: "#6d6d6d",
                  textAlign: "center",
                  marginBottom: "3rem",
                  lineHeight: "1",
                }}
              >
                Keeping dogs occupied for longer
              </h2>

              {/* First Paragraph */}
              <p
                style={{
                  fontSize: "20px",
                  color: "#888",
                  textAlign: "center",
                  lineHeight: "1.8",
                  marginBottom: "2.5rem",
                }}
              >
                Made to an ancient Himalayan recipe, perfected over hundreds of
                years.{" "}
                <span style={{ fontWeight: "bold", color: "#6d6d6d" }}>
                  Pup n Treats
                </span>{" "}
                are the ultimate 100% natural dog chew and occupier that will
                have your dog wagging their tail in delight!
              </p>

              {/* Second Paragraph */}
              <p
                style={{
                  fontSize: "20px",
                  color: "#888",
                  textAlign: "center",
                  lineHeight: "1.8",
                  marginBottom: "1rem",
                }}
              >
                Crafted with care, these chews not only provide endless
                entertainment but also offer a range of health benefits for
                dogs. With{" "}
                <span style={{ fontWeight: "bold", color: "#6d6d6d" }}>
                  Pup n Treats
                </span>{" "}
                you can bid farewell to plaque and tartar troubles, as these
                chews promote dental hygiene.
              </p>

              {/* Read More Button */}
              <div style={{ textAlign: "center" }}>
                <button
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    padding: "0.75rem 2rem",
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    color: "#9b7db5",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    position: "relative",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateX(5px)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateX(0)";
                  }}
                >
                  Read More
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={ArrowSign}
                      alt="Arrow Sign"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Image Section */}
      <div className="container-fluid">
          <img
            src={InfoSectionImage}
            alt="Pup n Treats Info"
            style={{ width: "100%", height: "auto", maxHeight: "800px", objectFit: "contain" }}
          />
      </div>
    </div>
  );
};

export default PupTreatsInfoSection;
